import { initWorklet } from './play-audio.js'

export default class WsVoip {
  constructor() {
    this.socket = null
  }
  async connect(url, eventListener) {
    this.socket = new WebSocket(url)
    this.socket.onopen = () => {
      eventListener.onopen()
    }
    this.socket.onmessage = (event) => {
      eventListener.onmessage(event)
    }
    this.socket.onerror = (error) => {
      eventListener.onerror(error)
    }
    this.socket.onclose = (event) => {
      eventListener.onclose(event)
    }
    this.workletNode = await initWorklet()
  }

  send(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(data)
    }
  }

  close() {
    if (this.socket) {
      this.socket.close(1000)
    }
  }
}
